// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import {OFFERS_SORTING} from '../../utils/constants.js';

export const SORT_ITEMS = [{
    id: OFFERS_SORTING.FAV,
    title: 'Most popular',
    ico: 'star',
}, {
    id: OFFERS_SORTING.AMOUNT_91,
    title: 'Highest Reward',
    ico: 'arrow_up',
}, {
    id: OFFERS_SORTING.AMOUNT_19,
    title: 'Lowest Reward',
    ico: 'arrow_down',
}];
export const OS_FILTERS = [{
    id: 'android',
    title: 'Android',
    ico: 'android_logo',
}, {
    id: 'ios',
    title: 'iOS',
    ico: 'apple_logo_inline',
}, {
    id: 'desktop',
    title: 'Desktop',
    ico: 'desktop_icon_sm',
}];
export const DEBOUNCE_MS = 200;
export const SORTING_KEY = 'order_by';
export const SEARCH_KEY = 'name';
export const OS_KEY = 'platforms';
export const PAGE_SIZE = 21;
export const PAGINATION_WINDOW_SIZE = 5;
